<template>
<div class="h-100">
    <BOrchestrator />
    <VipNavigation/>
    <div class="content">
        <NuxtPage />
        <PopupNotification v-if="isLoggedIn"/>
    </div>
    <SiteFooter/>
</div>
</template>

<script setup lang="ts">
//import VipNavigation from '~/components/vip/VipNavigation.vue'
import SiteFooter from '~/components/site/SiteFooter.vue'
import PopupNotification from '~/components/popup_notification/PopupNotification.vue'
import { useAuth } from '#imports'
import { computed } from 'vue'
const { status } = useAuth()
const { locale } = useI18n()
const isLoggedIn = computed(() => status.value === 'authenticated')

const { $apiFetch } = useNuxtApp()
const vipEventsStore = useVipEventsStore()
await useAsyncData(
  vipEventsStore.VIP_EVENTS_ASYNC_KEY,
  async () => {
    // Re-fetch when locale/auth changes so guest init does not stick forever
    vipEventsStore.reset()
    return vipEventsStore.ensureVipEvents(locale.value, $apiFetch)
  },
  { watch: [locale, isLoggedIn] },
)
</script>

<style scoped lang="scss">
.content{
    min-height: 82vh;
}
</style>